import { inject, Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	CanActivate,
	GuardResult,
	MaybeAsync,
	Router,
} from '@angular/router';
import { AuthService } from '../services';

/**
 * Prevents super admins from accessing the profile route. Supers do not have
 * org profiles and should be redirected to home when they try to access profile.
 */
@Injectable({ providedIn: 'root' })
export class ProfileAccessGuard implements CanActivate {
	private readonly authService = inject(AuthService);
	private readonly router = inject(Router);

	canActivate(_route: ActivatedRouteSnapshot): MaybeAsync<GuardResult> {
		if (this.authService.authUser?.role === 'super') {
			return this.router.createUrlTree(['/home']);
		}
		return true;
	}
}
